import type { AgentApiJobSourcesService } from '@/types/serializers';
import { useMemo } from 'react';
import useFetchJobSourcesServices from '@/features/agent/linked_accounts/api/useFetchJobSourcesServices';

type Props = {
  selectedServiceName: string;
  onAuthMethodSelect: (service: AgentApiJobSourcesService) => void;
};

export default function TrialAccountLinkStep2({ selectedServiceName, onAuthMethodSelect }: Props) {
  const { data: services } = useFetchJobSourcesServices();

  // 選択されたサービス名に関連するサービスを取得（TalentioとTalentio Openなど）
  const relatedServices = useMemo(() => {
    if (!services) return [];
    return services.filter(
      (service) =>
        service.name.includes(selectedServiceName) || selectedServiceName.includes(service.name)
    );
  }, [services, selectedServiceName]);

  return (
    <div className="flex w-full max-w-[940px] flex-col items-center gap-12">
      {/* タイトル */}
      <div className="flex flex-col items-center">
        <h1 className="text-center text-heading-xl text-black">
          {selectedServiceName}の追加方法を選択
        </h1>
      </div>

      {/* 認証方法選択カード */}
      <div className="flex w-full flex-wrap justify-center gap-md">
        {relatedServices.map((service, key) => (
          <button
            key={key}
            type="button"
            onClick={() => onAuthMethodSelect(service)}
            className="flex h-[360px] w-[270px] flex-col items-center justify-center gap-xl rounded-md bg-white p-4 shadow-layer1 transition-all hover:shadow-[0px_0px_12px_0px_rgba(0,0,0,0.2)]"
          >
            {/* アイコン */}
            <div className="flex size-[100px] items-center justify-center">
              <img
                src={service.image_url}
                alt={service.name}
                className="max-h-full max-w-full object-contain"
              />
            </div>

            {/* テキスト */}
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-center text-lg leading-normal font-bold text-black">
                {service.name}
              </h2>
              <p className="w-[238px] text-center text-sm leading-[1.7] whitespace-pre-wrap text-black">
                {service.description}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
